import React, { useState, useEffect } from "react"
// import { API } from "../../API"
import UploadAvatars from "./UploadAvatars"
// import HomeContainer from "../Container/HomeContainer";
import HomeContainer from "../Container/HomeContainer2"
// import TeacherProfile from "../Profile/TeacherProfile";
import TeacherProfile from "../Profile/TeacherProfile.redux"
import Spinner from "../../Components/Spinner/Spinner"
// import { notify } from "react-notify-toast"

//Yuan-redux
import { connect } from "react-redux"
import { updateToRoot, addCanDeliver } from "../../redux/homePage/homePage.actions"

//Jiazheng: redux store
// import store from "../../redux/store"
import Auth from "../../Auth/Auth"
import { API } from "../../API"

const tabs = [
  {
    pathname: "/",
    text: "Profile",
    active: true,
  },
  {
    pathname: "/resume",
    text: "Resume",
  },
]

function Home2(props) {
  const [user, setUser] = useState("")
  const [isUploadPopup, toggleUploadPopup] = useState(false)
  const { updateToRoot, addCanDeliver } = props
  const [qualificationList, setQualificationList] = useState()

  const handleUser = async () => {
    if (!window.localStorage.token || !Auth.authenticated) {
      const path = {
        pathname: "/login",
      }
      props.history.push(path)
    } else {
      const result = await API.getUserSafeData()
      setUser(result.data.user)
      return result.data.user
    }
  }

  // const handleCanDeliversChange = async (newUser) => {
  //   props.addCanDeliver(newUser)
  //   setUser({
  //     ...user,
  //     selected_can_delivers: newUser.selected_can_delivers
  //   })
  //   modifySelectedList(qualificationList, newUser)
  // }

  const handleQualification = () => {
    API.getQualificationList().then(result => {
      const qualifications = result?.data?.data
      setQualificationList(qualifications)
    })
  }

  useEffect(() => {
    handleUser().then(() => {
      handleQualification()
    })
    
  }, [])

  //upload avatar function
  const toggleUpload = (e) => {
    toggleUploadPopup(true)
  }
  const updateAvatarUser = (user) => {
    // console.log(user, "uese")
    updateToRoot(user)
  }
  let newUser

  if (user) {
    return (
      //Yuan: to check the new homeContainer
      <HomeContainer
        user={user}
        tabs={tabs}
        isViewAsTeacher={true}
        isShowWhereby={true}
        isShowUploadAvatar={true}
        tabProfileActive={true}
        uploadAvatar={toggleUpload}
        offset={true}
        isShowPoliceCheckWwcc={user?.is_childhood_teacher ? true : false}
      >
        {isUploadPopup && (
          <UploadAvatars
            showPopup={toggleUploadPopup}
            newUser={newUser}
            setUser={setUser}
            user={user}
            updateUser={updateAvatarUser}
          />
        )}
        
        {qualificationList?.length && <TeacherProfile
          isShowFooter={true}
          user={user}
          setUser={setUser}
          // addCanDeliver={(user) => handleCanDeliversChange(user)}
          // selectedItem={selectedList}
          qualifications={qualificationList}
          // selectedByQualification={selectedByQualification}
        />}
      </HomeContainer>
    )
  }
  // else return <div>Loading</div>;
  else return <Spinner />
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateToRoot: (user) => dispatch(updateToRoot(user)),
  addCanDeliver: (user) => dispatch(addCanDeliver(user))
})

export default connect(mapStateToProps, mapDispatchToProps)(Home2)
